import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDescriptionOff = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M45 12.146v-4h-3.024l2.868-2.869-2.121-2.121-4.989 4.99H3v4h30.734l-5.237 5.236H3v4h21.497l-5.236 5.236H3v4h12.26l-5.236 5.237H3v4h3.024l-2.868 2.868 2.121 2.121 4.989-4.989H38v-4H14.266l5.237-5.237H45v-4H23.503l5.236-5.236H38v-4h-5.261l5.237-5.236z" }) }) })
});
export default SvgDescriptionOff;
